const DoneIcon = () => {
  return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0C5.38125 0 0 5.38125 0 12C0 18.6187 5.38125 24 12 24C18.6187 24 24 18.6187 24 12C24 5.38125 18.6187 0 12 0Z"
          fill="#449F52"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8031 7.95488C18.0937 8.24551 18.0937 8.72363 17.8031 9.01426L10.7719 16.0455C10.6265 16.1908 10.4344 16.2658 10.2422 16.2658C10.05 16.2658 9.85779 16.1908 9.71248 16.0455L6.19685 12.5299C5.90623 12.2393 5.90623 11.7611 6.19685 11.4705C6.48748 11.1799 6.9656 11.1799 7.25623 11.4705L10.2422 14.4564L16.7437 7.95488C17.0344 7.65957 17.5125 7.65957 17.8031 7.95488Z"
          fill="white"
        />
      </svg>
  );
};
export default DoneIcon;
